"use strict";
var Player = (function () {
    function Player(id, name, affiliateNumber, isCore) {
        this.id = id;
        this.name = name;
        this.affiliateNumber = affiliateNumber;
        this.isCore = isCore;
    }
    return Player;
}());
exports.Player = Player;



/*****************
 ** WEBPACK FOOTER
 ** ./src/player.ts
 ** module id = 61
 ** module chunks = 1
 **/